/**
 * 扩展vue
 * 将统一操作的api 扩展到vue原型对象上.
 * 确保是扩展到 vue 实例化之前的对象上.
 */

import vue from 'vue';

export default{
    install(Vue, opts = {}){

        //Vue.prototype.$loading = Loading.service;

    }
};




// WEBPACK FOOTER //
// ./src/plugins/extended.js